import * as actions from '../live-nurses.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { NoteItem } from 'src/app/recruiting/candidates/live-nurses-new/components/notes/models/dto/note-item';

export interface SubmittalNotesState {
    notes: NoteItem[];
    loading: LoadingTypes;
}

const initialState: SubmittalNotesState = {
    notes: [],
    loading: LoadingTypes.INIT
};

export function liveNursesSubmittalNotesReducer(state: SubmittalNotesState, action: Action) {
    return createReducer(
        initialState,
        on(actions.loadNotesForSubmittal, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING
        })),

        on(actions.loadNotesForSubmittalSuccess, (state, action) => {
            const otherNotes = state.notes.filter((n) => !action.notes.map((an) => an.id).includes(n.id));
            return {
                ...state,
                notes: [...otherNotes, ...action.notes],
                loading: LoadingTypes.LOADED
            };
        }),

        on(actions.loadNotesForSubmittalFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED
        })),

        on(actions.addNote, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING
        })),

        on(actions.addNoteSuccess, (state, action) => {
            return {
                ...state,
                notes: [...state.notes, action.note],
                loading: LoadingTypes.LOADED
            };
        }),

        on(actions.addNoteFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED
        }))
    )(state, action);
}

export function reducer(state: SubmittalNotesState | undefined, action: Action) {
    return liveNursesSubmittalNotesReducer(state, action);
}
